import React from "react";
import Icon from "./Icon";
export default function Play(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("path", {
    d: "M5.58337 1.75L19.5834 10.75L5.58337 19.75V1.75Z"
  }));
}
Play.displayname = "Play";
//# sourceMappingURL=Play.js.map